module.exports = __webpack_public_path__ + "media/images/mv_img_sp-90587ed58b72ace4b5b9bef4d59d3731.png";